<template lang="pug">
b-modal(
  v-model="isVisible"
  size="xl"
  centered
  hide-footer
  no-close-on-backdrop
  content-class="exception-detail-ovg-modal"
  @hidden="$emit('close')"
)
  template(#modal-header="{ close }")
    .modal-header-content.w-100.d-flex.justify-content-between.align-items-start
      div
        h4.modal-title.font-weight-bold.mb-2(v-if="detail")
          | Solicitud de Excepción OVG {{ detail.ovg_id }}
        div(v-if="detail")
          span.status-pill.status-pending(v-if="detail.estado === 'PENDIENTE'")
            b-icon.mr-1(icon="clock")
            | Pendiente
          span.status-pill.status-approved(v-else-if="detail.estado === 'APROBADO'")
            b-icon.mr-1(icon="check-circle")
            | Aceptado
          span.status-pill.status-rejected(v-else)
            b-icon.mr-1(icon="x-circle")
            | Rechazado
      b-button.close-btn(variant="link" @click="close")
        b-icon(icon="x" font-scale="1.6")

  .modal-body-content(v-if="loading")
    .text-center.py-5
      b-spinner(variant="warning" label="Cargando...")
      p.mt-3.text-muted Cargando información de la excepción...

  .modal-body-content(v-else-if="error")
    .text-center.py-5
      b-icon(icon="exclamation-circle" variant="danger" font-scale="3")
      p.mt-3.text-danger {{ error }}
      b-button(variant="secondary" @click="$emit('close')") Cerrar

  .modal-body-content(v-else-if="detail")
    b-row
      //- Columna izquierda: Datos, precios, comentarios y acciones
      b-col(cols="12" lg="8").pr-lg-4
        //- Datos del Cliente
        .section-box.mb-3
          .section-title.d-flex.align-items-center.mb-2
            b-icon.mr-2(icon="person-fill")
            span.font-weight-bold Datos del Cliente
          b-row.data-grid
            b-col(cols="6" sm="4").data-item
              span.data-label R.U.T.
              span.data-value.text-primary.font-weight-bold {{ detail.datos_cliente.rut || '-' }}
            b-col(cols="6" sm="4").data-item
              span.data-label Teléfono
              span.data-value {{ detail.datos_cliente.telefono || '-' }}
            b-col(cols="6" sm="4").data-item
              span.data-label Correo
              span.data-value {{ detail.datos_cliente.correo || '-' }}
            b-col(cols="6" sm="4").data-item
              span.data-label Nombre
              span.data-value {{ detail.datos_cliente.nombre || '-' }}
            b-col(cols="6" sm="4").data-item
              span.data-label Apellido
              span.data-value {{ detail.datos_cliente.apellido || '-' }}

        //- Datos del Equipo
        .section-box.mb-3
          .section-title.d-flex.align-items-center.mb-2
            b-icon.mr-2(icon="laptop")
            span.font-weight-bold Datos del Equipo
          b-row.data-grid
            b-col(cols="6").data-item
              span.data-label Modelo
              span.data-value.font-weight-bold {{ detail.datos_equipo.modelo || '-' }}
            b-col(cols="6").data-item
              span.data-label Marca
              span.data-value {{ detail.datos_equipo.marca || 'Asus' }}

        //- Detalle de Precios
        .section-box.mb-3
          .section-title.d-flex.align-items-center.mb-2
            b-icon.mr-2(icon="credit-card")
            span.font-weight-bold Detalle de Precios
          .table-responsive
            table.table.table-sm.pricing-table.mb-0
              thead
                tr
                  th Concepto
                  th.text-right Precio Catálogo
                  th.text-right Precio Editado
                  th.text-right Rebaja Unitaria
              tbody
                tr(v-for="(item, idx) in detail.detalle_precios" :key="idx")
                  td {{ item.concepto }}
                  td.text-right {{ formatCurrency(item.precio_catalogo) }}
                  td.text-right {{ formatCurrency(item.precio_editado) }}
                  td.text-right.text-danger.font-weight-bold
                    | -{{ formatCurrency(item.rebaja_unitaria) }}

        //- Resumen Total
        .summary-card.mb-3
          .summary-title.d-flex.align-items-center.mb-2
            b-icon.mr-2(icon="receipt")
            span.font-weight-bold Resumen Total
          .summary-row.d-flex.justify-content-between.py-1
            span.summary-label Unidades Aplicadas
            span.summary-val.font-weight-bold {{ detail.resumen_total.unidades_aplicadas }}
          .summary-row.d-flex.justify-content-between.py-1
            span.summary-label Precio Original
            span.summary-val {{ formatCurrency(detail.resumen_total.precio_original) }}
          .summary-row.d-flex.justify-content-between.py-1
            span.summary-label Rebaja Total
            span.summary-val.text-danger -{{ formatCurrency(detail.resumen_total.rebaja_total) }}
          hr.my-2
          .summary-row.d-flex.justify-content-between.align-items-center.pt-1
            span.summary-total-label.font-weight-bold Precio Final Total
            span.summary-total-val.font-weight-bold {{ formatCurrency(detail.resumen_total.precio_final_total) }}

        //- Comentario de la solicitud
        .comment-box.mb-3(v-if="detail.comentario_solicitud")
          span.font-weight-bold.d-block.mb-1 Comentario de la Solicitud
          p.comment-text.mb-0 {{ detail.comentario_solicitud }}

        //- Si está resuelto (Aprobado o Rechazado): info de respuesta
        .resolved-box.mb-3(v-if="detail.estado !== 'PENDIENTE'")
          b-row
            b-col(cols="6" sm="4").data-item
              span.data-label(v-if="detail.estado === 'APROBADO'") Aprobado por
              span.data-label(v-else) Rechazado por
              span.data-value.font-weight-bold
                | {{ detail.respondido_por_nombre || '-' }}
            b-col(cols="6" sm="4").data-item
              span.data-label Fecha
              span.data-value {{ formatDate(detail.fecha_respuesta) }}
          div.mt-2(v-if="detail.comentario_respuesta")
            span.data-label Comentario de resolución
            p.comment-text.mb-0 {{ detail.comentario_respuesta }}

        //- Si está pendiente: input para resolución y botones Aprobar / Rechazar
        div.mt-3(v-if="detail.estado === 'PENDIENTE'")
          b-form-group(label="Comentario" label-class="font-weight-bold mb-1")
            b-form-textarea(
              v-model="resolutionComment"
              placeholder="Si es necesario, deja algún comentario."
              rows="2"
              no-resize
            )
          .d-flex.justify-content-end.mt-3
            b-button.btn-reject.mr-2(
              variant="danger"
              :disabled="actionLoading"
              @click="handleAction('rechazar')"
            )
              b-spinner(v-if="actionLoading && currentAction === 'rechazar'" small)
              span(v-else) Rechazar Solicitud
            b-button.btn-approve(
              variant="success"
              :disabled="actionLoading"
              @click="handleAction('aprobar')"
            )
              b-spinner(v-if="actionLoading && currentAction === 'aprobar'" small)
              span(v-else) Aprobar Excepción

        //- Si no está pendiente: botón Cerrar
        div.d-flex.justify-content-end.mt-3(v-else)
          b-button.btn-close-yellow(
            @click="$emit('close')"
          ) Cerrar

      //- Columna derecha: Panel de Series
      b-col(cols="12" lg="4").mt-3.mt-lg-0.border-left-lg
        .series-panel
          .section-title.d-flex.align-items-center.mb-2
            b-icon.mr-2(icon="laptop")
            span.font-weight-bold Panel de Series
          .search-serial-wrapper.mb-2
            b-input-group(size="sm")
              template(#prepend)
                b-input-group-text
                  b-icon(icon="search")
              b-form-input(
                v-model="serialSearch"
                placeholder="Buscar por N° de Serie"
              )
          .serial-count.text-muted.small.mb-2
            | Mostrando {{ filteredSeries.length }} de {{ detail.series.length }} series
          .serial-list-scroll
            div(v-if="filteredSeries.length === 0").text-center.text-muted.py-4
              | No se encontraron series
            div(
              v-else
              v-for="(sn, idx) in filteredSeries"
              :key="idx"
              class="serial-item-card"
            )
              span.serial-text {{ sn }}
</template>

<script>
import { mapActions } from 'vuex'
import moment from 'moment'

export default {
  name: 'ExceptionDetailModalOVG',
  props: {
    exceptionId: {
      type: [Number, String],
      required: true,
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isVisible: false,
      loading: false,
      error: null,
      detail: null,
      serialSearch: '',
      resolutionComment: '',
      actionLoading: false,
      currentAction: null,
    }
  },
  computed: {
    filteredSeries() {
      if (!this.detail || !this.detail.series) return []
      const q = (this.serialSearch || '').trim().toLowerCase()
      if (!q) return this.detail.series
      return this.detail.series.filter((s) => s.toLowerCase().includes(q))
    },
  },
  watch: {
    visible: {
      immediate: true,
      handler(val) {
        this.isVisible = val
        if (val && this.exceptionId) {
          this.fetchDetail()
        }
      },
    },
    isVisible(val) {
      if (!val) {
        this.$emit('close')
      }
    },
  },
  methods: {
    ...mapActions('OVGCenterStore', [
      'getExcepcionOVGDetail',
      'gestionarExcepcionOVG',
    ]),
    async fetchDetail() {
      this.loading = true
      this.error = null
      try {
        const data = await this.getExcepcionOVGDetail(this.exceptionId)
        this.detail = data
        this.resolutionComment = ''
      } catch (err) {
        console.error('Error fetching OVG exception detail:', err)
        this.error =
          err?.response?.data?.error ||
          'No se pudo cargar el detalle de la excepción'
      } finally {
        this.loading = false
      }
    },
    async handleAction(accion) {
      this.actionLoading = true
      this.currentAction = accion
      try {
        const updated = await this.gestionarExcepcionOVG({
          id: this.exceptionId,
          accion,
          comentario: this.resolutionComment,
        })
        this.detail = updated
        this.$bvToast.toast(
          accion === 'aprobar'
            ? 'Excepción aprobada exitosamente'
            : 'Excepción rechazada',
          {
            title: 'Gestión de Excepción',
            variant: accion === 'aprobar' ? 'success' : 'danger',
            solid: true,
            autoHideDelay: 3000,
          }
        )
        this.$emit('action-completed', { id: this.exceptionId, accion })
      } catch (err) {
        console.error('Error gestionando excepción OVG:', err)
        const msg =
          err?.response?.data?.error ||
          err?.response?.data?.detail ||
          'No se pudo procesar la acción'
        this.$bvToast.toast(msg, {
          title: 'Error',
          variant: 'danger',
          solid: true,
          autoHideDelay: 4000,
        })
      } finally {
        this.actionLoading = false
        this.currentAction = null
      }
    },
    formatCurrency(val) {
      if (val === null || val === undefined) return '$0'
      const num = Math.round(Number(val))
      return `$${num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')}`
    },
    formatDate(dateStr) {
      if (!dateStr) return '-'
      return moment(dateStr).format('DD/MM/YYYY')
    },
  },
}
</script>

<style lang="scss" scoped>
.exception-detail-ovg-modal {
  border-radius: 12px;
}

.modal-header-content {
  border-bottom: none;
}

.close-btn {
  color: #333;
  padding: 0;
  &:hover {
    color: #000;
  }
}

.status-pill {
  display: inline-flex;
  align-items: center;
  padding: 4px 12px;
  border-radius: 16px;
  font-size: 0.85rem;
  font-weight: 600;

  &.status-pending {
    background-color: #fff3cd;
    color: #856404;
    border: 1px solid #ffeeba;
  }
  &.status-approved {
    background-color: #d4edda;
    color: #155724;
    border: 1px solid #c3e6cb;
  }
  &.status-rejected {
    background-color: #f8d7da;
    color: #721c24;
    border: 1px solid #f5c6cb;
  }
}

.section-box {
  background-color: #ffffff;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  padding: 12px 16px;
}

.section-title {
  color: #212529;
  font-size: 0.95rem;
}

.data-grid {
  .data-item {
    margin-bottom: 8px;
    display: flex;
    flex-direction: column;
  }
  .data-label {
    font-size: 0.75rem;
    color: #6c757d;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }
  .data-value {
    font-size: 0.9rem;
    color: #212529;
  }
}

.pricing-table {
  thead th {
    background-color: #f1f3f5;
    font-size: 0.8rem;
    text-transform: uppercase;
    color: #495057;
    border: none;
  }
  tbody td {
    vertical-align: middle;
    font-size: 0.88rem;
  }
}

.summary-card {
  background-color: #fffcf0;
  border: 1px solid #f9e8a2;
  border-radius: 8px;
  padding: 14px 16px;

  .summary-label {
    color: #495057;
    font-size: 0.9rem;
  }
  .summary-val {
    font-size: 0.95rem;
  }
  .summary-total-label {
    font-size: 1rem;
    color: #212529;
  }
  .summary-total-val {
    font-size: 1.25rem;
    color: #212529;
  }
}

.comment-box,
.resolved-box {
  background-color: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  padding: 10px 14px;

  .comment-text {
    font-size: 0.9rem;
    color: #495057;
  }
}

.btn-reject {
  background-color: #fa383e;
  border-color: #fa383e;
  font-weight: 600;
  padding: 8px 18px;
  border-radius: 6px;
}

.btn-approve {
  background-color: #2ecc71;
  border-color: #2ecc71;
  font-weight: 600;
  padding: 8px 18px;
  border-radius: 6px;
}

.btn-close-yellow {
  background-color: #fece2f;
  border: none;
  color: #000;
  font-weight: 600;
  padding: 8px 24px;
  border-radius: 6px;
  &:hover {
    background-color: darken(#fece2f, 8%);
  }
}

.border-left-lg {
  @media (min-width: 992px) {
    border-left: 1px solid #e9ecef;
  }
}

.series-panel {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.serial-list-scroll {
  max-height: 400px;
  overflow-y: auto;
  padding-right: 4px;
}

.serial-item-card {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  padding: 7px 12px;
  margin-bottom: 6px;
  font-family: monospace;
  font-size: 0.88rem;
  color: #333;
}
</style>
